import { TopicInfoState } from "@/mk2/apps/forum/containers/TopicInfo/TopicInfo.reducers";
import { LoadingState } from "@/mk2/reducers/loadingState";

export const initialTopicInfoState: TopicInfoState = {
    topicId: null,
    loadingState: LoadingState.INIT,
    errorMessage: null,
    moderatorsDetailsId: null,
};
